module.exports = __webpack_public_path__ + "static/Anshul-Jain.3e371d68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/Anshul-Jain.jpg
// module id = 911
// module chunks = 146520050992020